var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"icon-template",attrs:{"src":require(`@/assets/ui-icons/${_vm.name}.svg`),"alt":_vm.name},on:{"load":_vm.setMask}})
}
var staticRenderFns = []

export { render, staticRenderFns }